import AdminLayout from "./layouts/AdminLayout";

export default function Dashboard() {
  return (
    <AdminLayout title="Dashboard">
      <div className="row g-4">
        <div className="col-md-4">
          <div className="card shadow-sm h-100">
            <div className="card-body">
              <h5 className="card-title">Welcome</h5>
              <p className="card-text mb-0">
                Use the sidebar to manage users, aircrafts, airlines, roles and seats.
              </p>
            </div>
          </div>
        </div>
      </div>
    </AdminLayout>
  );
}
